module.exports = __webpack_public_path__ + "static/media/logo_bizon-prefab--small.731a5c89.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/logo_bizon-prefab--small.svg
// module id = 246
// module chunks = 0